import { subWeeks, startOfDay, endOfDay } from "date-fns";
import {
  DatagridConfigurable,
  List,
  TextField,
  NumberField,
  BooleanField,
  TopToolbar,
  SelectColumnsButton,
  Pagination,
} from "react-admin";

import { FILTER_LIMITS } from "@/constants/filters";
import { DateFieldWithStandardFormat } from "@/fields/DateFieldWithStandardFormat";
import { IsoDateInput } from "@/inputs/IsoDateInput";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
  </TopToolbar>
);

export const ReceiptsList = () => (
  <List
    actions={<ListActions />}
    filterDefaultValues={{
      subscriptionCreatedAt: {
        after: startOfDay(subWeeks(new Date(), 1)),
        before: endOfDay(new Date()),
      },
    }}
    filters={[
      <IsoDateInput
        key="from"
        label="Date From"
        source="subscriptionCreatedAt.after"
        isRequired={false}
        alwaysOn
      />,
      <IsoDateInput
        key="to"
        label="Date To"
        source="subscriptionCreatedAt.before"
        isRequired={false}
        alwaysOn
      />,
    ]}
    storeKey={false}
    perPage={FILTER_LIMITS[0]}
    pagination={<Pagination rowsPerPageOptions={FILTER_LIMITS} />}
  >
    <DatagridConfigurable
      bulkActionButtons={false}
      omit={["updatedAt", "createdAt"]}
    >
      <TextField source="id" sortable={false} />
      <TextField source="transactionId" sortable={false} />
      <TextField source="originalTransactionId" sortable={false} />
      <TextField source="webOrderLineItemId" sortable={false} />
      <DateFieldWithStandardFormat
        source="originalPurchaseDate"
        sortable={false}
      />
      <TextField source="productId" sortable={false} />
      <NumberField source="quantity" sortable={false} />
      <DateFieldWithStandardFormat source="purchaseDate" sortable={false} />
      <DateFieldWithStandardFormat source="expiresDate" sortable={false} />
      <BooleanField source="isTrialPeriod" sortable={false} />
      <DateFieldWithStandardFormat source="cancellationDate" sortable={false} />
      <TextField source="cancellationReason" sortable={false} emptyText="-" />
      <TextField source="installId" sortable={false} />
      <DateFieldWithStandardFormat
        source="subscriptionCreatedAt"
        sortable={false}
      />
      <NumberField source="price" sortable={false} />
      <TextField source="clientAppId" sortable={false} />
      <TextField source="currency" sortable={false} />
      <DateFieldWithStandardFormat source="updatedAt" sortable={false} />
      <DateFieldWithStandardFormat source="createdAt" sortable={false} />
    </DatagridConfigurable>
  </List>
);
